/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-15 13:34:21
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-16 14:11:27
 * @Description: 发票收取
 * @FilePath: \ICPSxin\src\api\internetSales\invoiceManagement.js
 */
export const queryPage = '/icps/system/sign/intelligent/invoice/getInvoicesPage'
export const Download = '/icps/system/sign/intelligent/invoice/exportInvoice'
import request from '@/utils/request'
// 保存发票
export function saveInvoice(data) {
    return request({
        url: '/icps/system/sign/intelligent/invoice/saveInvoice',
        method: 'POST',
        data
    })
}
// 查询合同
export function getContract(data) {
    return request({
        url: '/icps/system/sign/dataCollection/contract/QueryPage',
        method: 'POST',
        data
    })
}
// 删除
export function deleteInvoice(data) {
    return request({
        url: '/icps/system/sign/intelligent/invoice/deleteInvoice',
        method: 'POST',
        data
    })
}
export function queryListsByPid(data) {
    //查询list协作单位
    return request({
      url: "/icps/system/sign/dataCollection/cooperation/queryListsByPid",
      method: "post",
      data,
    });
  }
